import React from "react";

const Logo = () => {
  return (
    <img src="/images/icon.svg" alt="sent. logo" style={{height: "1em"}}/>
  );
};

export default Logo;
